import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter } from "react-router-dom";
import { HamburgerProvider } from "./context/hamburgerState";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <HamburgerProvider>
          <App />
        </HamburgerProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
